/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
/* eslint-disable no-loop-func */
import React, { useState, useEffect } from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import './Legend.css';
import { useTranslation } from 'react-i18next';
import RSU from '../../../images/RSU.svg'


function Legend() {
    const viewboxTCU = "0 0 16 8";
    const { t } = useTranslation();
    var leyenda = (JSON.parse(sessionStorage.getItem("Legend")));
    var [htmlLeyenda, sethtmlLeyenda] = useState(<></>);


    useEffect(() => {
        let tabsList = [];//Lista de pestañas
        let aux = []; //Array auxiliar para reorganizar la lista de estados por tecnología
        let temp = [];//Array temporal
        leyenda.map((dato) => {//Obtenemos los nombres de las pestañas de la leyenda
            const { name } = dato;
            if (!tabsList.includes(name)) {
                tabsList.push(name);
            }
        })

        for (var i = 0; i < tabsList.length; i++) {//Filtramos la lista de estados por el nombre de la
            temp = leyenda.filter(a => a.name === tabsList[i]);
            aux.push(temp);
        }


        var htmlLe = aux.map((dato, i) => {
            var name_aux = '';
            var rsuCom = <></>;
            var rsuOp = <></>;
            var pr = <></>;
            var listaInv1 = <></>;
            var listaInv2 = <></>;


            var htmlaux = dato.map((dato2, index) => {
                const { type, status, color, description, name } = dato2;

                // Si el color de fondo es blanco, añade un borde negro para que no se mezcle con el fondo
                let border = 'none';
                if (color === '#ffffff' || color === 'white') {
                    border = '2px solid black';
                }

                if (name !== "PLC" && name !== "Digi" && name !== " ") {
                    name_aux = name;
                }

                switch (name) {
                    case "NCU":
                        return (
                            <tr key={index}>
                                <td>{description}</td>
                                <td>
                                    <svg className='svg-ncu-tamaño'>
                                        <circle style={{ fill: color, stroke: "none", strokeWidth: "0.1", border: border }} id="circulo" cx="13" cy="13" r="13" />
                                    </svg>
                                </td>
                            </tr>)

                    case "TCU":
                        return (
                            <tr key={index}>
                                <td>{description}</td>
                                <td>
                                    <svg className="svg-tcu-tamaño" viewBox={viewboxTCU}>
                                        <rect style={{
                                            opacity: "0.89", fill: color, fillOpacity: "1", stroke: "#000", strokeWidth: "0.4", strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: "4",
                                            strokeDasharray: "none", strokeOpacity: "1", border: border
                                        }}
                                            id="fondo" width="15.496825" height="7.5599341" x="0.19208001" y="0.17274463" ry="0" />
                                    </svg>
                                </td>
                            </tr>)

                    case "RSU":
                        if (type === "operation") {
                            rsuOp = <>{rsuOp}<dd>{description}<div className='square_rsuOp' style={{ backgroundColor: color, border: border }} /></dd></>
                        } else {
                            rsuCom = <>{rsuCom}<dd ><div className='square_rsuCom' style={{ backgroundColor: color, border: border }} />{description}</dd></>
                        }

                        break;
                    case "CT":
                        return (
                            <tr key={index}>
                                <td>{description}</td>
                                <td>
                                    <div className='squareCT' style={{ backgroundColor: color, border: border }} />
                                </td>
                            </tr>)

                    case "Inverter":
                        if (type === "productivity") {
                            pr = <>{pr}<dd>{status}<div className='square' style={{ backgroundColor: color, border: border }} /></dd></>
                        } else {
                            if (index <= (dato.length / 2 - 3)) { // Si quitas el -3 se hace un lio. no lo borres porfi
                                listaInv1 = <>{listaInv1}<dd>{status}<div className='square' style={{ backgroundColor: color, border: border }} /></dd></>
                            } else {
                                listaInv2 = <>{listaInv2}<dd>{status}<div className='square' style={{ backgroundColor: color, border: border }} /></dd></>
                            }
                        }
                        break;
                    default:
                        return;
                }
            })

            if (name_aux !== "RSU" && name_aux !== "Inverter" && name_aux !== "") {
                return (<Tab eventKey={name_aux} title={name_aux} key={'tablegend' + i}>
                    <center>
                        <table>
                            <thead className="texto-centrado-leyenda" key={'tabhead' + i}>
                                <tr key={'lnf' + i}>
                                    <th>{t('scada.map.legend.status')}</th>
                                </tr>
                            </thead>

                            <tbody>
                                {htmlaux}
                            </tbody>
                        </table>
                    </center>
                </Tab>)
            } else if (name_aux === "Inverter") {
                return (<Tab eventKey={name_aux} title={name_aux} key={'tab2legend' + i}>
                    <h5 id='inverterEstados' style={{ marginLeft: "20rem" }}>{t('scada.map.legend.status')}</h5>
                    <dl id="statusInv1">
                        {listaInv1}
                    </dl>
                    <dl id="statusInv2">
                        {listaInv2}
                    </dl>

                    <dl id="statusInvPR">
                        <dt style={{ margin: "0 auto" }}>{t('scada.map.legend.statusProductivity')}</dt>
                        {pr}
                    </dl>
                </Tab>)
            } else if (name_aux === "RSU") {
                return (<Tab eventKey={name_aux} title={name_aux} key={'tab3legend' + i}>

                    <dl id="rsuEstOp">
                        <dt>{t('scada.map.legend.statusOperation')}</dt>
                        {rsuOp}
                    </dl>
                    <img id="svg-rsu-tamaño" src={RSU} alt="rsu" />
                    <dl id="rsuEstCom">
                        <dt>{t('scada.map.legend.statusCommunication')}</dt>
                        {rsuCom}
                    </dl>

                </Tab>)
            }

        })
        sethtmlLeyenda(htmlLe);
    }, [])

    return (
        <Tabs>
            {htmlLeyenda}
        </Tabs>
    )
}

export default Legend